import { connect } from 'react-redux'
import { get } from 'lodash'
import { reduxForm } from 'redux-form'
import SayPlayForm from './SayPlayForm'

const stateToProps = ({ form }, otherProps) => ({
  formData: get(form, `${otherProps.form}.values`, {}),
  initialValues: {
    loop: '1',
    voice: 'man',
    ...otherProps.initialValues,
  },
})

const dispatchToProps = {}

export default connect(
  stateToProps,
  dispatchToProps
)(
  reduxForm({
    destroyOnUnmount: true,
  })(SayPlayForm)
)



// WEBPACK FOOTER //
// ./src/features/Flows/Flow/Nodes/SayPlay/SayPlayForm.container.js